import yup from 'config/yup';

export default yup.object().shape({
  name: yup.string().required(),
  email: yup.string().required(),
  profile_id: yup.number().required(),
  phoneNumber: yup
    .string()
    .matches(/^(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})/g, 'Número inválido')
    .required(),
  password: yup.string().required(),
});
